import { render } from "./CarruselOfertasComponent.vue?vue&type=template&id=104d633d&scoped=true"
import script from "./CarruselOfertasComponent.vue?vue&type=script&lang=js"
export * from "./CarruselOfertasComponent.vue?vue&type=script&lang=js"

import "./CarruselOfertasComponent.vue?vue&type=style&index=0&id=104d633d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-104d633d"]])

export default __exports__